<template>
  <div class="Pay">
    <!-- <article>
          <input type="radio" :name="pay.uId" @click="check" v-model="pay.ischeck" />
    </article> -->
    <div class="left">
      <van-radio  :name="pay.uId"></van-radio>
    </div>
    <div class="right">
      <div class="header">
        <div class="c_top">
          <div>
            <span>{{ pay.chargeName }}</span>
          </div>
        </div>
        <div class="c_center">
          <div>
            <span>费用年度：{{ pay.period }}</span>
            &nbsp;|&nbsp; 费用季度：{{ pay.quarterName }}
          </div>
          <div class="icd" @click.stop="toggleShow">
            <img
              v-show="!showD"
              class="ic"
              src="../assets/img/downDraw.png"
              alt=""
            />
            <img
              v-show="showD"
              class="ic"
              src="../assets/img/upDraw.png"
              alt=""
            />
          </div>
        </div>
        <div class="c_bot">
          <span class="bot_txt">支付金额</span>
          <div class="bot_yang">
            <span class="yang">¥</span>&nbsp;{{ pay.actualTotal }}
          </div>
        </div>
      </div>
      <div class="footer" v-if="showD">
        <div class="foot_c" v-for="item in pay.itemList" :key="item.itemId">
          <span>
            {{ item.itemName }}
          </span>
          <span> {{ item.actualAmt }}元 </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  // 封装 代缴费 列表为组件
  props: {
    payInfo: {
      type: Object,
      default: null,
      required: true,
    },
    showDL: Boolean,
  },
  data() {
    return {
      activeNames: ["1"],
      pay: {},
      showD: false,
    };
  },
  watch: {
    showDL(val) {
      this.showD = val;
    },
  },
  created() {
    // console.log(this.payInfo);
    for (var i in this.payInfo) {
      this.pay[i] = this.payInfo[i];
    }
    // console.log(this.pay);
  },
  methods: {
    toggleShow() {
      this.showD = !this.showD;
      if (!this.showD) {
        this.$emit("toggle", false);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
input[type="checkbox"] {
  width: 16px;
  height: 16px;
  background-color: #fff;
  line-height: 16px;
  border-radius: 2px;
  color: #fff;
  text-align: center;
  border: 1px dashed #999;
}

.Pay {
  border-radius: 6px;
  background: #fff;
  width: 345px;
  margin: 0px auto;
  display: flex;
  padding: 20px;
  box-sizing: border-box;
  .left {
    margin-top: 30px;

    ::v-deep .van-radio__icon {
      width: 26px;
      height: 26px;
      .van-icon-success {
        width: 26px;
        height: 26px;
        line-height: 26px;
        // border: none;
        border: 1.73px solid rgba(204, 204, 204, 1);
        // border-radius: 3.47px;
        // border-radius: 4px;
        text-align: center;
      }
    }

    ::v-deep .van-radio__icon--checked {
      .van-icon-success {
        background-image: linear-gradient(135deg, #0272fc 0%, #92bcff 100%);
        width: 26px;
        height: 26px;
        line-height: 28px;
        border: none;
        // border-radius: 4px;
        font-size: 22px;
        text-align: center;
      }
    }
  }
  .right {
    width: 264px;
    margin-left: 14px;
    padding-top: 2px;
  }
  article {
    position: relative;
    .bor {
      width: 16px;
      height: 16px;
      border: 1px dashed #333;
    }
  }
  input {
    width: 17px;
    height: 17px;
    margin-right: 9px;
    margin-top: 4px;
    // outline: 1px dashed #333;
    border: 0px;
  }
}
.header {
  // padding-top: 12px;
  // padding-left: 16px;
  padding-bottom: 0px;

  .c_top {
    width: 220px;
    word-break: break-all;
    // font-size: 16px;

    font-size: 20px;
    color: #464a4c;
    letter-spacing: 0;
    font-weight: 700;
  }
}
.c_bottom {
  font-size: 12px;
}

.header {
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #2e3133;
  line-height: 23px;
  .top {
    display: flex;
    justify-content: space-between;
  }
  .c_bottom {
    display: flex;
    justify-content: space-between;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #9ea4a9;
    line-height: 20px;
  }
}
.c_center {
  font-size: 10px;
  color: #777;
  margin-top: 9px;
  margin-bottom: 9px;

  font-size: 14px;
  color: #999999;
  letter-spacing: 0;
  line-height: 25px;
  font-weight: 400;
  // position: relative;
  .icd {
    position: absolute;
    display: flex;
    align-items: center;
    right: 63px;
    top: 28px;
    color: #1989fa;
  }
  .ic {
    margin-left: 4px;
    width: 16px;
    height: 8px;
  }
}
.c_bot {
  .bot_txt {

    font-size: 16px;
    color: #464a4c;
    letter-spacing: 0;
    font-weight: 400;
  }
  .bot_yang {

    font-size: 16px;
    color: #F46C6C;
    letter-spacing: 0;
    text-align: right;
    font-weight: 700;
  }
  margin-top: 10px;
  font-size: 18px;
  color: #F46C6C;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.footer {
  margin-top: 10px;
  padding: 12px 0px;
  border-top: 1px dashed #eeeeee;
  transition: 1.5s;
  padding-bottom: 0px;
  .foot_c {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 14px;

    font-size: 16px;
    color: #464a4c;
    letter-spacing: 0;
    font-weight: 400;
    span:nth-of-type(1){
      margin-right: 10px;
    }
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: all 0.4s ease;
}

.fade-enter-from,
.fade-leave-to {
  // height: 0px;
  opacity: 0;
}
.fade-enter-to,
.fade-leave-from {
  // height: 100px;
  opacity: 1;
}
</style>
